import { Component, OnInit } from '@angular/core';
import { BackOffServiceService } from 'src/app/services/back-off-service.service';
import { FormGroup, FormControl, FormBuilder, Validators, ValidationErrors } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { QuizData } from '../QuizData';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
// import { userInfo } from 'os';
import { environment } from 'src/environments/environment';
import * as Parse from 'parse';
import { NgbdModalContent } from '../../alert-component';
import { CookieService } from 'ngx-cookie-service';
import { UserData } from 'src/app/model/UserData';

@Component({
  selector: 'app-phoneandemail',
  templateUrl: './phoneandemail.component.html',
  styleUrls: ['./phoneandemail.component.css']
})
export class PhoneandemailComponent implements OnInit {
  phoneForm : FormGroup;
  submitted: boolean = false;
  
  successMessage: string;
  failedMessage: string;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private  _bkoffService: BackOffServiceService,
    private formBuilder : FormBuilder,
    private modalService: NgbModal,
    private cookie : CookieService,

    ) {
      Parse.initialize(environment.PARSE_APP_ID, environment.PARSE_JS_KEY);
      (Parse as any).serverURL = environment.serverURL;
    }

  ngOnInit() {
    let regexPatterns = {
      weight: '[0-9][0-9][0-9]-[0-9][0-9][0-9]-[0-9][0-9][0-9][0-9]',
   };
    this.phoneForm  =  this.formBuilder.group({
      phone: ['', [Validators.required, Validators.pattern(regexPatterns.weight)]],
       
    });

    this.router.events.subscribe((evt) => {
      window.scrollTo(0, 0)
    });
  }

  get fmBuilder() { return this.phoneForm.controls; }  

  reset(){
    this.phoneForm.reset({PersonalData: new QuizData()});
  }

  getFormValidationErrors() {
    var missingInput = false;
    Object.keys(this.phoneForm.controls).forEach(key => {
    const controlErrors: ValidationErrors = this.phoneForm.get(key).errors;
    if (controlErrors != null) {
          Object.keys(controlErrors).forEach(keyError => {
            console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
            if (keyError === "required"){
              missingInput = true;
            }
          });
        }
      });
      return missingInput;
    }

  btnclick(){
    const result: QuizData = Object.assign({}, this.phoneForm.value);
    let fromResult = Object.assign({}, result);

    this.submitted = true;

    console.log("about to check form validation");
    // stop here if form is invalid
    if (this.phoneForm.invalid) {
      const modalRef = this.modalService.open(NgbdModalContent);
      if (this.getFormValidationErrors()){
        modalRef.componentInstance.name = 'You have left a question unanswered';
      }
      else{
        modalRef.componentInstance.name = 'Enter the Phone Number xxx-xxx-xxxx format';
      }
        return;
    }

     const signUpData = this.phoneForm;
     
      var userInfo = new UserData();

      userInfo.phone_number = String(signUpData.get(['phone']).value)
  
      this._bkoffService.setPhone(userInfo);
    
    this.router.navigateByUrl('/registeredThanks');    
  };

}
